import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './safehtml.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [SafeHtmlPipe],
    exports: [SafeHtmlPipe],
})

export class CommonPipesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/common-pipes.module.ts